import * as React from 'react';
import classNames from 'classnames';
import { IEventWrapper } from './EventWrapper.interfaces';
import './_style.scss';
import { FulfillmentTypes } from '../../../../../modules/slotManagement/pages/SlotsTemplatesEdit/pageParts/constants';

const clx = 'cal_eventWrapper';
export enum shoppingModeType {
  '11111111-1111-1111-1111-111111111111' = 'pickup',
  '22222222-2222-2222-2222-222222222222' = 'delivery',
  '33333333-3333-3333-3333-333333333333' = 'planning',
}

const EventWrapper = (props: IEventWrapper) => {
  const { className, event, type, children } = props;
  const { disabled, modified = false, template, data = {} } = event as any;
  const { shoppingModeId, fulfillmentType, fulfilmentType, isClosed, supportedServiceType } = data;
  const sm = shoppingModeType[shoppingModeId];

  const classMap = {
    [`${clx}--${type}`]: type,
    // If sameDayOnly is true, then use the timeframeInMinutes for the event template, default to 120
    [`${clx}--template-${(supportedServiceType?.sameDayOnly
        ? `${supportedServiceType?.timeframeInMinutes === 120 || supportedServiceType?.timeframeInMinutes === 300 ? supportedServiceType?.timeframeInMinutes : '120'}-minutes`
        : null) ?? fulfillmentType?.value ?? fulfillmentType ?? fulfilmentType}`]: supportedServiceType?.sameDayOnly || fulfillmentType || fulfilmentType,
    [`${clx}--template-${template}`]: template,
    [`${clx}--shoppingMode-${sm}`]: sm,
    [`${clx}--isUpdated`]: modified,
    [`${clx}--disabled`]: disabled,
    [`${clx}--isExpired`]: data.isExpired,
    [`${clx}--isClosed`]: isClosed,
    [`${clx}--expired-delivery`]: data.isExpired && (sm === 'delivery'),
    [`${clx}--expired-pickup`]: data.isExpired && (sm=== 'pickup'),
    [`${clx}--expired-instacart`]: data.isExpired && (fulfillmentType?.value?.toLowerCase() || fulfilmentType?.toLowerCase()) === FulfillmentTypes.Instacart.toLowerCase(),
    [`${clx}--expired-120-minutes`]: data.isExpired && supportedServiceType?.sameDayOnly && supportedServiceType?.timeframeInMinutes === 120,
    [`${clx}--expired-300-minutes`]: data.isExpired && supportedServiceType?.sameDayOnly && supportedServiceType?.timeframeInMinutes === 300,
    [`${clx}--expired-blocked`]: data.isExpired && data.isBlocked ,
    [`${clx}--expired-orphan`]: data.isExpired && data.isOrphan,
    [`${clx}--expired-closed`]: data.isExpired && data.isClosed,
  };
  return <td className={classNames(clx, classMap, className)}>{children}</td>;
};

export default EventWrapper;
